function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.5466 1.36184L19.0162 0.191082C18.8985 -0.0687043 18.72 -0.0628507 18.6196 0.20409L17.8159 2.33923C17.6606 2.75165 17.7007 2.84988 18.1185 3.00714L20.2536 3.81084C20.5206 3.91132 20.6426 3.78103 20.5249 3.52124L20.062 2.4994C20.0387 2.46137 20.0176 2.42678 19.9983 2.39489C20.0938 2.38888 20.1897 2.3686 20.28 2.33616C20.3294 2.31841 20.3796 2.30279 20.4306 2.28936C20.6735 2.22528 20.9271 2.21239 21.1753 2.25149C21.4235 2.2906 21.6608 2.38085 21.8723 2.51653C22.0837 2.65221 22.2647 2.83035 22.4037 3.03965C22.5427 3.24896 22.6366 3.48486 22.6796 3.7324C22.7226 3.97994 22.7137 4.23371 22.6534 4.47762C22.5932 4.72153 22.4829 4.95026 22.3296 5.1493C22.2974 5.19102 22.2635 5.23125 22.228 5.26989C22.0063 5.51114 21.8902 5.86694 22.0474 6.15448C22.2045 6.44202 22.5701 6.55167 22.8212 6.34106C22.9867 6.20222 23.1371 6.04553 23.2697 5.87347C23.5233 5.54418 23.7058 5.16577 23.8055 4.76223C23.9052 4.3587 23.9199 3.93886 23.8488 3.52932C23.7777 3.11979 23.6222 2.72951 23.3923 2.38323C23.1623 2.03695 22.863 1.74223 22.5131 1.51776C22.1633 1.29329 21.7706 1.14398 21.36 1.07928C20.9494 1.01458 20.5298 1.03591 20.1279 1.14193C19.9265 1.19505 19.7317 1.26886 19.5466 1.36184Z",
  fill: "#00BB77"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.81738 8.57837L12.0887 12.7863L19.3106 8.60305",
  stroke: "#00BB77",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0879 20.2471V12.7781",
  stroke: "#00BB77",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 10.003V14.6639C20.0001 16.5332 19.4986 17.1803 18.7575 17.7684C17.3897 18.8537 15.5607 19.1963 13.7911 20.173C12.8523 20.7 11.3206 20.7 10.3819 20.173L5.98449 17.7355C4.98808 17.1838 4.17285 15.8003 4.17285 14.6639V10.003C4.17285 8.86659 4.98808 7.48316 5.98449 6.93142L10.3819 4.4939C11.3206 3.96688 12.8523 3.96688 13.7911 4.4939L18.1885 6.93142C19.1849 7.48316 20.0001 8.86659 20.0001 10.003Z",
  stroke: "#00BB77",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgOfferingIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOfferingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/offering-icon.440771a5.svg";
export { ForwardRef as ReactComponent };